export const TYPE_CHARSHEET_SAVAGE_WORLD = 1;
export const TYPE_CHARSHEET_CUSTOM = 2;
export const TYPE_CHARSHEET_CYBERPUNK = 3;
